import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';


import { CurrencyFormat } from '../../../../utils';


import useAccessoriesData from '../../../hooks/useAccessoriesData';
import useConfiguratorData from '../../../hooks/useConfiguratorData';
import useFinanciadoData from '../../../hooks/useFinanciadoData';
import useLinksData from '../../../hooks/useLinksData';

import usePriceData from '../../../hooks/usePriceData';


const ModalConfigurationDetailBody = ({ onCloseModal }) => {

    const { getAddedAccessories, getIgnoreAccessories } = useAccessoriesData();
    const { getSelectedModel, getSelectedVersion, getSelectedColor, getSelectedPrepaidMaintenancePlan } = useConfiguratorData();
    const { getIgnoreFinanciado, getPreApproved, getFinanciado, getUsado } = useFinanciadoData();
    const { getFinancedTotal } = usePriceData();
    const { getLinks } = useLinksData();

    const addedAccessories = getAddedAccessories();
    const ignoreAccessories = getIgnoreAccessories();
    const ignoreFinanciado = getIgnoreFinanciado();
    const selectedModel = getSelectedModel();
    const selectedVersion = getSelectedVersion();
    const selectedColor = getSelectedColor();
    const financedTotal = getFinancedTotal();
    const financiado = getFinanciado();
    const preApproved = getPreApproved();
    const links = getLinks();
    const usado = getUsado();
    const history = useHistory();
    const selectedPrepaidMaintenancePlan = getSelectedPrepaidMaintenancePlan();

    const financingLegend = () => {

        if (financiado.smart_buy && preApproved) { 
            return 'Financiado con Plan Renueve y preaprobación del mismo';
        }

        if (financiado.smart_buy && !preApproved) {
            return 'Financiado con Plan Renueve';
        }

        if (!financiado.smart_buy && preApproved) {
            return 'Financiado y preaprobado';
        }

        if (!financiado.smart_buy && !preApproved) {
            return 'Financiado ';
        }
    }

    const includeLegend = () => {
        if(selectedPrepaidMaintenancePlan && (addedAccessories.length > 0 && !ignoreAccessories.value)){
            return " (Incluye Accesorios y MPP)";
        }

        if(!selectedPrepaidMaintenancePlan && (addedAccessories.length > 0 && !ignoreAccessories.value)){
            return " (Incluye Accesorios)";
        }

        if(selectedPrepaidMaintenancePlan && ignoreAccessories.value){
            return " (Incluye MPP)";
        }
        return "";
    }

    const totalPriceAccesories = () => {
        let result = 0;
        addedAccessories.forEach(accesorie => result += accesorie.price);
        return result;
    }

    return (
        <div className="modal-box">
            <div className="close-button icon close" id="close-modal" onClick={onCloseModal}></div>
            <div className="modal-header">
                <div className="modal-title">
                    <h1>
                        { selectedModel?.name } { selectedVersion?.name } | 
                        <strong>{ CurrencyFormat(financedTotal) }</strong>
                        <small className='green-tax'>+I.V. { CurrencyFormat(selectedVersion.green_tax) }</small>
                    </h1>
                    <p>Detalle de configuración.</p>
                </div>
            </div>
            <div className="modal-body">
                <section className="config-section">
                    <h4>Caraterísticas Generales</h4>
                    <p>{ selectedVersion?.main_features.map(feature => feature.description).join(', ') }</p>
                    { selectedColor?.name ? <p><strong>Color exterior:</strong> { selectedColor?.name }</p> : null}
                </section>

                <section className="config-section underlined">
                    <div className="split">
                        <h4>{selectedModel?.name} {selectedVersion?.name}</h4>
                        <span className="big-number">{  CurrencyFormat(financedTotal)} <sup>(&lowast;)</sup></span>
                    </div>
                    <div className='split green-tax'>
                        <p>Impuesto verde</p>
                        <span className='green-tax'>+{ CurrencyFormat(selectedVersion.green_tax) }</span>
                    </div>
                </section>

                { !ignoreAccessories.value ? (
                    <section className="config-section">
                        <div className="split">
                            <h4>Accesorios Seleccionados ({addedAccessories.length })</h4>
                            <span className="big-number">{CurrencyFormat(totalPriceAccesories())}<sup>(1)</sup></span>
                            {/* <a className="btn link-arrow btn-config-edit" onClick={() => history.goBack()}>Editar <i className="icon chevron-right "></i></a> */}
                        </div>
                        { addedAccessories.map(accesory => (
                            <div className="list-item" key={`confg-detail-accesory-${accesory.id}`}>
                                <div className="split">
                                    <span className="item-name">{ accesory.name }</span>
                                    <span>{ CurrencyFormat(accesory.price) }</span>
                                </div>
                            </div>
                        )) }
                        
                    </section>
                ) : null }

                {selectedPrepaidMaintenancePlan ? 
                    <section className="config-section underlined">
                        <div className="split">
                            <h4>Mantenciones Prepagadas (MPP) - {selectedPrepaidMaintenancePlan.name}</h4>
                            <span className="big-number">{  CurrencyFormat(selectedPrepaidMaintenancePlan.price)} <sup>(2)</sup></span>
                        </div>
                    </section>
                : null}

                <section className="config-section underlined">
                    <h4>Opción de pago</h4>
                    <div className="split">
                        {ignoreFinanciado.value ? (
                            <>
                                <span>Contado</span>
                                <span>&nbsp;</span>
                            </>
                        ): (
                            <>
                                    <span>{ financingLegend() + includeLegend()}</span>
                                    <span className="big-number">{financiado.number_fees} cuotas de {CurrencyFormat(financiado.fee_value) } <sup>(*)</sup></span>
                            </>
                        )}
                        
                    </div>
                </section>
                {usado.patent ? 
                    <section className="config-section underlined">
                        <h4>Tu usado como parte de pago</h4>
                        <div className="split">
                            <span>{usado.details.make} / {usado.details.model} / {usado.selectedVersion.name} / <br/>{usado.details.year} / {usado.mileage.name} {`${usado.checkedMaintenance ? "/ Con mantenciones al día" : ""}`}</span>
                            <span> De {CurrencyFormat(usado.range.min)} a {CurrencyFormat(usado.range.max)} <sup className="big-sup">(3)</sup></span>
                        </div>
                    </section>
                : null}
                
                <div className="disclaimer">
                    <p>
                        (*) Nuestro precio sugerido incluye bono marca y condiciones de financiación. Para más detalle ver <a href={links.tnc_by_model_page} target="_blank">términos y condiciones comerciales</a>.
                    </p>
                    {!ignoreAccessories.value && addedAccessories.length > 0 && <p>
                        (1) Precios sugeridos. El valor por la instalación no está incluido en el precio publicado y varia por concesionario.
                    </p>}
                    {usado.patent ? 
                        <p>(3)El valor indicado es meramente referencial y no vinculante, no constituye oferta de compra vinculante para Toyota Chile S.A. o su Red Oficial de Concesionarios, y fue generado en base a la información proporcionada por el propio cotizante. La tasación final del vehículo usado dependerá del estado y condición en que se encuentre el vehículo a la fecha de la revisión e inspección técnica realizada por tasadores de manera presencial en las dependencias del Concesionario Toyota seleccionado. De esta manera, producto de la tasación, el valor final podría llegar a variar en relación con el indicado inicialmente en esta plataforma de acuerdo al uso y estado técnico mecánico en que se encuentre el vehículo a la fecha de la tasación.</p>
                    : null}
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn black" onClick={onCloseModal}>Aceptar</button>
            </div>
        </div>
    )
};

export default ModalConfigurationDetailBody;